export default function BadgesConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('badges');
}

BadgesConfiguration.$inject = ['$translatePartialLoaderProvider'];
